import React, { forwardRef } from 'react';
import Link from 'next/link';

const MenuItemLink = forwardRef((props, ref) => <Link ref={ref} {...props} />);

export default MenuItemLink;
